module.exports = __webpack_public_path__ + "img/failedQrcode.95e0da6.png";